module.exports = __webpack_public_path__ + "imgs/star-full-yellow.9fdef97b78a82785c200d84c7f1943cd.svg";